import { useState } from "react"
import { getCallreport } from "../../../apis/BhuMeetTeams/Telecaller/requestqueue"
import Popup from "../../../ReusableFunctions/Popup"
import { useSelector } from "react-redux"
import { Button } from "../../../Components/Helper"
import { AddCrmcallHistory } from "../../../BhuMeetTeams/CRM/createCrmCallHistory"
import { InitiateCall } from "../../../apis/BhuMeetTeams/Crm/leadsCallHistory"



export const InitiateTeleCall = ({ state }) => {

    const userDetails = useSelector(state => state.user?.user)
    const [openCallhistory, setopenCallhistory] = useState(false)
    const [refresh, setrefresh] = useState(0)
    const [CallActive, setCallActive] = useState(false)
    const [campid, setCampid] = useState()

    const checkCallReport = async (campid) => {
        try {

            const interval = setInterval(async () => {
                const CallReport = await getCallreport()

                let findspecificCall = CallReport.filter(x => x.sid_id == campid)

                if (findspecificCall[0]?.sid_id) {
                    setCampid(findspecificCall[0].sid_id);
                    // setlastRecord(true)
                    setrefresh((prev) => prev + 1);

                    // Stop further executions as the condition is met
                    setCallActive(false)
                    setopenCallhistory(true)
                    clearInterval(interval)


                }

            }, 5000)


        } catch (err) {
            console.log(err)

        }
    }


    const handleCall = async (toCall) => {
        try {
            setCallActive(true)
            let call = await InitiateCall(toCall, state.id, userDetails.phone, state.name,'user')
            setCallActive(false)
            checkCallReport(call.callDetail.campid)
            Popup.alert("SUCCESS", "Call initiated Successfully", "SUCCESS")
            return

        } catch (err) {
            setCallActive(false)
            return Popup.alert("ERROR", err, "ERROR")
        }

    }


    return (
        <>
            <Button style={{ height: "25px", fontSize: "14px",whiteSpace:"nowrap" }}
                type="submit"
                // icon={Plus}
                isDisabled={CallActive}
                text={"Call"}
                onClick={() => { handleCall(state.mobile_number); }}
            />


            {openCallhistory &&
                <AddCrmcallHistory open={openCallhistory} data={{campid:campid,lead_id:state.id,campaign_id:state.campaign_id}} onClose={() => { setopenCallhistory(false); setrefresh(refresh + 1) }} isEdit={true} />
            }

        </>
    )
}